import { FieldError as FieldErrorOriginal } from 'old-rhf';

/**
 * @deprecated use FieldError from react-hook-form package instead
 */
export interface FieldError {
  type: 'required' | 'minLength' | 'invalid';
  message?: string;
}

export interface WithErrors {
  errors?: FieldError | FieldErrorOriginal;
  clearErrors?: (name?) => void;
  requiredErrorMessage?: string;
}

const generateErrorMessage = (options: WithErrors): string | undefined => {
  if (!options.errors) {
    return undefined;
  }

  if (options.errors.type === 'required' && options.requiredErrorMessage) {
    // TODO i18n here!
    return options.requiredErrorMessage;
  }

  // TODO i18n here!
  return options.errors.message;
};

interface ParseErrorsResult {
  hasErrors: boolean;
  errorMessage?: string;
}

/**
 * @deprecated This component will be removed after the RHF migration is complete. Use the ZZMForm equivalent from @zazume/zzm-base instead.
 */
export const parseErrors = <T extends WithErrors>(withErrors: T): ParseErrorsResult => ({
  hasErrors: Boolean(Object.keys(withErrors.errors || {}).length),
  errorMessage: generateErrorMessage(withErrors)
});
